<template>
  <div id="app" :class="touchClass">
    <transition name="slide-fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <main-menu></main-menu>
  </div>
</template>

<script>
import MainMenu from './components/MainMenu.vue'

export default {
  name: 'app',
  components: {
    MainMenu
  },
  computed: {
    touchClass () {
      return {
        'touch': window.isTouch,
        'no-touch': !window.isTouch
      }
    }
  },
  watch: {
    '$route' () {
      const transitionDuration = 300
      setTimeout(function () {
        window.scrollTo(0, 0)
      }, transitionDuration)
    }
  }
}
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// App.vue?681ac798